import * as React from 'react'

import {SpinnerOverlay} from '@frontrow/console/src/components/spinner'

type Props = {
  isLoading: boolean
  children: React.ReactNode
}

export default function SpinnerWrapper(props: Props): React.ReactElement {
  const {isLoading, children} = props

  return isLoading ? <SpinnerOverlay /> : <>{children}</>
}
